export default "__VITE_ASSET__B_89m0mI__"